// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__koM+i","active":"MenuItem_active__84noT","icon":"MenuItem_icon__5+ICi","label":"MenuItem_label__xTMAB","collapsed":"MenuItem_collapsed__uKnmS"};